<template>
	<el-row :gutter="24" class="content">
		<el-col :span="12">
			<GcGroupDetail :data="deviceBasicInfo" />
			<CloseValveAlarmReason :detail="detail" />
		</el-col>
		<el-col :span="12">
			<DiagnosisAnalyze isAnalyzeDetails :detail="detail" resultKey="valveResult" />
		</el-col>
		<el-col :span="24" class="box-table">
			<CloseValveCmdRecords :detail="detail" />
		</el-col>
	</el-row>
</template>

<script>
import DiagnosisAnalyze from '../components/DiagnosisAnalyze'
import CloseValveAlarmReason from '../components/CloseValveAlarmReason.vue'
import CloseValveCmdRecords from '../components/CloseValveCmdRecords'
export default {
	components: { DiagnosisAnalyze, CloseValveCmdRecords, CloseValveAlarmReason },
	props: {
		detail: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {}
	},
	computed: {
		deviceBasicInfo() {
			return {
				title: '设备信息',
				row: 2,
				labelWidth: 75,
				list: [
					{
						key: 'deviceNo',
						label: '设备通讯编号',
						value: this.detail.deviceNo,
					},
					{
						key: 'deviceTypeName',
						label: '设备型号',
						value: this.detail.deviceTypeName,
					},
					{
						key: 'valveStatus',
						label: '阀门状态',
						value: this.detail.valveStatus,
					},
					{
						key: 'lastCommunicateTime',
						label: '最新通讯时间',
						value: this.detail.lastCommunicateTime,
						col: 2,
					},
				],
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.content {
	height: 100%;
	overflow: hidden;
}
.box-table {
	height: calc(100% - 180px);
}

::v-deep .group-detail-item .group-detail-name {
	width: 100px !important;
}
</style>
